import ReactECharts from "echarts-for-react";
import * as echarts from "echarts";

export default function BarChartsHorizontal({
  data,
  heading,
  gradient1,
  gradient2,
}) {
  if (!data || !data.keyData || !data.valData) {
    return null; // or handle loading state here if needed
  }

  const options = {
    title: {
      text: heading,
      left: "left",
      textStyle: {
        fontFamily: "Uni Neue",
        fontSize: 16,
        fontWeight: "600",
      },
    },
    tooltip: {
      trigger: "axis",
      axisPointer: {
        type: "shadow",
      },
    },
    legend: {},
    grid: {
      top: "18%",
      left: "5%",
      right: "5%",
      bottom: "1%",
      containLabel: true,
    },
    xAxis: {
      show: false,
    },
    yAxis: {
      type: "category",
      data: data.keyData,
      axisLabel: {
        fontSize: 12,
      },
      axisTick: {
        show: false,
      },
    },
    series: [
      {
        data: data.valData,
        type: "bar",
        barWidth: 15,
        barMinHeight: 25,
        itemStyle: {
          barBorderRadius: [0, 7, 7, 0],
          color: new echarts.graphic.LinearGradient(0, 0, 1, 0, [
            { offset: 0, color: gradient1 },
            { offset: 1, color: gradient2 },
          ]),
        },
        label: {
          show: true,
          position: "insideRight",
          formatter: "{c}",
          color: "#fff",
          fontSize: 10,
        },
      },
    ],
  };

  return <ReactECharts option={options} style={{ height: 160 }} />;
}
